<template>
  <div>
    <h5 class="mb-4">{{ $t("smartVoiceTokensTitle") }}</h5>
    <b-form class="form-container" @submit.prevent="submitForm">
      <div v-if="isLoading" class="py-5 text-center"><b-spinner/></div>
      <template v-if="!isLoading" >
        <b-form-group label-for="radio-locked-out" :label="$t('useFullSystem')">
          <b-form-radio-group id="radio-locked-out" :options="lockedOutOptions"
                              v-model="lockedOut" name="lockedOut"></b-form-radio-group>
        </b-form-group>

        <b-form-group>
          <template v-slot:label>Authorization <span class="text-danger">*</span></template>
          <b-form-input type="text" v-model="authorization" required :disabled="lockedOut"/>
        </b-form-group>
        <b-form-group>
          <template v-slot:label>Token ID <span class="text-danger">*</span></template>
          <b-form-input type="text" v-model="tokenId" required :disabled="lockedOut"/>
        </b-form-group>
        <b-form-group>
          <template v-slot:label>Token Key <span class="text-danger">*</span></template>
          <b-form-input type="text" v-model="tokenKey" required :disabled="lockedOut"/>
        </b-form-group>
        <b-form-group>
          <template v-slot:label>Domain (GRPC) <span class="text-danger">*</span></template>
          <b-form-input type="text" v-model="domain" required :disabled="lockedOut"/>
        </b-form-group>
        <b-form-group>
          <template v-slot:label>Port (GRPC) <span class="text-danger">*</span></template>
          <b-form-input type="text" v-model="port" required :disabled="lockedOut"/>
        </b-form-group>
        <div class="text-muted small mb-3 d-flex time-info align-items-center">
          <div v-if="createdAt">{{ $t("createdDate") }}: {{ formatDate(createdAt) }}</div>
          <div v-if="createdAt && modifiedAt" style="font-size: 1.25rem; font-weight: bold;">•</div>
          <div v-if="modifiedAt">{{ $t("updateDate") }}: {{ formatDate(modifiedAt) }}</div>
        </div>
        <div class="text-center">
          <b-button type="submit" variant="primary" :disabled="isSubmitting" class="mt-4">Cập nhật</b-button>
        </div>
      </template>
    </b-form>
  </div>
</template>

<style lang="scss" scoped>
  .time-info {
    gap: 0.5rem; // hoặc 8px
  }
</style>
<script lang="ts">
  import { Component } from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as customerService from "@/service/customerService";
  import { SmartVoiceToken } from '@/model/SmartVoiceToken';
  import { sanitizeObject } from "@/service/util";

  @Component
  export default class SmartVoiceTokens extends BaseComponent {
  public isChanged = false;
    public isSubmitting = false;
    public isLoading = false;

    public lockedOut = false;
    public authorization = "";
    public tokenId = "";
    public tokenKey = "";
    public domain = "";
    public port = "";

    public id: number | null = null;
    public adminUsers: any[] = [];
    public createdAt: Date | null = null;
    public modifiedAt: Date | null = null;

    get lockedOutOptions() {
      return [
        { value: false, text: this.$t("no").toString() },
        { value: true, text: this.$t("yes").toString(), disabled: this.isManager() },
      ];
    }

    mounted() {
      this.id = +this.$route.params.id || null;
      if (this.id) {
        this.fetchCustomer();
      }
    }

    private async fetchCustomer() {
      this.isLoading = true;
      try {
        const tokenInfo = await customerService.getSmartVoiceTokenByUser(this.id) as SmartVoiceToken;
        if (tokenInfo) {
          this.mapTokenInfo(tokenInfo);
        }
      } catch (e) {
        this.toastErrorOldType(e);
      } finally {
        this.isLoading = false;
      }
    }

    private async submitForm() {
      this.isLoading = true;
      try {
        const updatedData = sanitizeObject<SmartVoiceToken>({
          authorization: this.authorization,
          tokenId:       this.tokenId,
          tokenKey:      this.tokenKey,
          domainGRPC:    this.domain,
          portGRPC:      this.port,
          useOfSystem:   this.lockedOut ? 1 : 0,
        });        

        ///
        const res = await customerService.updateSmartVoiceToken(this.id as number, updatedData);
        if (res?.data) {
          this.mapTokenInfo(res.data);
        }

        ///
        this.toastSuccessDelay(this.$t("updateSmartVoiceSuccessful").toString());
      } catch (error) {
        this.toastErrorOldType(error);
      } finally {
        this.isLoading = false;
      }
    }

    private mapTokenInfo(tokenInfo: SmartVoiceToken) {
      this.authorization = (tokenInfo.authorization || "").trim();
      this.tokenId = (tokenInfo.tokenId || "").trim();
      this.tokenKey = (tokenInfo.tokenKey || "").trim();
      this.domain = (tokenInfo.domainGRPC || "").trim();
      this.port = (tokenInfo.portGRPC || "").trim();
      this.lockedOut = tokenInfo.useOfSystem === 1;
      this.createdAt = tokenInfo.createdAt;
      this.modifiedAt = tokenInfo.modifiedAt;
    }

    public formatDate(dateStr: string | Date | null): string {
      if (!dateStr) return "-";
      const date = new Date(dateStr);
      return new Intl.DateTimeFormat("vi-VN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      }).format(date);
    }
  }
</script>